import type { Program } from '@efdigital/ll-addon-data/types/xceed/program';
import { findProgram } from '@efdigital/ll-admin-v2/data/builders/xceed/programs';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export type ParamsProgramId = {
  program_id: string;
};

export type ProgramsProgramModel = ParamsProgramId & {
  program: Program;
};

export default class ProgramsProgramRoute extends Route<ProgramsProgramModel> {
  @service declare store: Store;

  async model(params: ParamsProgramId) {
    return {
      ...params,
      program: (await this.store.request(findProgram(params.program_id)))
        .content.data,
    };
  }
}
